import React from 'react';

import {
    Notification,
    NotificationPropsType
} from './components/notification';
import { NotificationModalWrapper } from './notification-modal.styled';

export const NotificationModal = (props: NotificationPropsType) =>
    (
        <NotificationModalWrapper>
            <Notification {...props} />
        </NotificationModalWrapper>
    );
